import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const services = [{
  id: 'signature-drinks',
  title: 'SIGNATURE DRINKS',
  image: 'https://cdn.magicpatterns.com/uploads/kHZKGpuftEu32wyoQC1Vk4/image.png',
  description: "Expertly crafted cocktails, sophisticated mocktails, and refreshing smoothies tailored to your event's unique vibe."
}, {
  id: 'desserts',
  title: 'DESSERTS',
  image: 'https://cdn.magicpatterns.com/uploads/haGyB1F9QNH8WgNaXRiVbc/ChatGPT_Image_Jun_17,_2026,_06_02_59_PM.png',
  description: 'Indulge in a luxurious selection of shooters, artisanal cake pops, and fresh fruit cups designed for the perfect sweet finish.'
}, {
  id: 'bites',
  title: 'BITES',
  image: 'https://cdn.magicpatterns.com/uploads/6nzZm75QAGWKmcR2E8PxBe/image.png',
  description: 'Savory delights featuring our signature shawarma and gourmet bites, prepared with premium ingredients and impeccable flair.'
}];
export function ServicesGrid() {
  return <section className="relative w-full py-20 overflow-hidden bg-[#050505]" data-id="element-109">
      {/* Subtle Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#992f74]/5 rounded-full blur-[120px] pointer-events-none" data-id="element-110"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12" data-id="element-111">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16 text-center flex flex-col items-center justify-center" data-id="element-112">
          <div className="flex items-center gap-4 mb-4" data-id="element-113">
            <span className="text-4xl md:text-5xl font-light tracking-widest text-white uppercase font-montserrat" data-id="element-114">
              OUR
            </span>
            <span className="font-dancing text-6xl md:text-7xl text-[#992f74]" data-id="element-115">
              Services
            </span>
          </div>
          <div className="w-24 h-[1px] bg-gradient-to-r from-transparent via-[#992f74] to-transparent" data-id="element-116"></div>
        </motion.div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12" data-id="element-117">
          {services.map((service, idx) => <Link key={service.id} to={`/services#${service.id}`} className="block" data-id="element-118">
              <motion.div initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.2,
            duration: 0.8,
            ease: 'easeOut'
          }} className="group flex flex-col bg-[#0A0A0A] border border-white/5 rounded-2xl overflow-hidden hover:border-[#992f74]/30 transition-all duration-500 hover:-translate-y-2 shadow-2xl h-full" data-id="element-119">
                {/* Image Container */}
                <div className="relative w-full aspect-[4/3] overflow-hidden" data-id="element-120">
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors duration-500 z-10" data-id="element-121"></div>
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-1000 ease-in-out" data-id="element-122" />
                </div>

                {/* Content Container */}
                <div className="p-8 flex flex-col flex-grow relative" data-id="element-123">
                  {/* Decorative Line */}
                  <div className="absolute top-0 left-8 right-8 h-[1px] bg-gradient-to-r from-transparent via-white/10 to-transparent" data-id="element-124"></div>

                  <h3 className="font-montserrat text-2xl text-[#992f74] font-bold tracking-wide mb-4 text-center" data-id="element-125">
                    {service.title}
                  </h3>

                  <p className="text-white/70 text-sm leading-relaxed text-center font-light font-montserrat" data-id="element-126">
                    {service.description}
                  </p>
                </div>
              </motion.div>
            </Link>)}
        </div>

        {/* Call to Action Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8
      }} className="mt-1 flex justify-center" data-id="element-127">
          <a href="/services" className="relative overflow-hidden group bg-transparent border border-[#992f74] text-[#992f74] px-12 py-4 text-xs font-bold tracking-[0.2em] uppercase transition-all duration-300 hover:text-black inline-block" data-id="element-128">
            <span className="relative z-10" data-id="element-129">What We Offer</span>
            <div className="absolute inset-0 h-full w-full bg-[#992f74] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" data-id="element-130"></div>
          </a>
        </motion.div>
      </div>
    </section>;
}